import { useCallback, useMemo } from "react"
import { useTheme, BottomNavigationAction, Box, Avatar } from "@mui/material"
import { useTranslation } from "providers/i18n"
import { useVenue } from "providers/venue"
import { gtmPushDataLayerSelectLanguage } from "utils/googletagmanager"

export const LanguageButtonMenu = (props) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const { locales = [] } = useVenue()

  const { styleOverrides = {} } = theme.components[`LanguageButtonMenu`] || {}
  const { wrapper, button, avatar } = styleOverrides

  const switchLanguage = useCallback(
    (lang) => (e) => {
      i18n.changeLanguage(lang)
      gtmPushDataLayerSelectLanguage(lang)
    },
    [i18n]
  )
  const activeLocale = useMemo(() => {
    if (!i18n.resolvedLanguage) return
    return locales.find((locale) => i18n.resolvedLanguage === locale.localeKey)
  }, [locales, i18n.resolvedLanguage])

  const { localeKey: activeLocaleKey } = activeLocale || {}

  return (
    <Box sx={wrapper}>
      {locales.map((locale) => (
        <BottomNavigationAction
          sx={button}
          icon={
            <Avatar
              src={`https://flagcdn.com/h40/${locale.flagCode}.webp`}
              sx={avatar}
            />
          }
          label={t(locale.localizedName)}
          showLabel
          key={locale.localeKey}
          onClick={switchLanguage(locale.localeKey)}
          selected={locale.localeKey === activeLocaleKey}
          {...props}
        />
      ))}
    </Box>
  )
}
